import React from "react"
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { FormSectionElements } from "src/entities/formTemplateDataType";


interface Props {
    isEng: boolean;
    field: FormSectionElements;
}

export class InformationalAlertComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);
        let field =this.props.field;
        FormValidationUtils.runJavascript(field);
       
    }

    generateHtmlString = () => {
        const field =this.props.field;
        let html = [];
        const HtmlToReactParser = require('html-to-react').Parser;
        const htmlToReactParser = new HtmlToReactParser(); 
        const bodyMsg= this.props.isEng? field.MessageBody: field.MessageBodyFRA; 
        let bodyHtml;
        if(/<[a-z][\s\S]*>/i.test(bodyMsg)){
            bodyHtml=htmlToReactParser.parse(bodyMsg);
        }

        const title = this.props.isEng?field.MessageTitle:field.MessageTitleFRA
        bodyHtml = bodyHtml===''||!bodyHtml ?(htmlToReactParser.parse(this.props.isEng?field.callOutBoxBody:field.callOutBoxBodyFRA)):bodyHtml;
if(field.Visible){
       html.push(
            <div className="ontario-alert ontario-alert--informational">
                <div className="ontario-alert__header">
                    <div className="ontario-alert__header-icon">
                        <svg className="ontario-icon"  aria-hidden="true" focusable="false"  viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-information"></use>
                        </svg>
                    </div>
                    <h4 className="ontario-alert__header-title ontario-h4">{title}</h4>
                    {(!title || title==='') && (
                        <div className="">
                            <p>{bodyHtml}</p>
                        </div>
                    )}
                </div>

                {(title && title!=='') && (
                <div className="ontario-alert__body">
                    <p>{bodyHtml}</p>
                </div>
                )}
            </div>
        );
}
     
        return html;
    }


    render() {
      //  console.log(this.props.Visible);
        return (
             this.generateHtmlString()
        )
    }
}
